// answers is an object keyed by answer id; flags duplicate value entries.
const getDuplicateAnswerError = (answers) => {
    const answerList = Object.values(answers);

    const optionValues = answerList
        .map((answer) => (typeof answer.option === 'string' ? answer.option.trim().toLowerCase() : answer.option))
        .filter((option) => !!option);
    if (optionValues.some((option, index) => optionValues.indexOf(option) !== index)) {
        return 'Answer values must be unique.';
    }

    return undefined;
};

export { getDuplicateAnswerError };
